import ajax from '../utils/ajaxHelper';
import { useCallback } from 'react';
import { useNavigate } from 'react-router-dom';
import Cookies from 'js-cookie';
import CryptoJS from 'crypto-js';

const useForms = () => {
  const key = 'iFrasCwdJh';
  const userCookie = Cookies.get('user');
  let bytes = CryptoJS.AES.decrypt(userCookie, key);
  const loggedInUserData = JSON.parse(bytes.toString(CryptoJS.enc.Utf8));
  const navigate = useNavigate();
  const getAllFormTypes = useCallback(async (val) => {
    try {
      return await ajax.post(`forms/get-all-from-types`, val);
    } catch (error) {
      return error;
    }
  });

  const getAllQuestionTypes = useCallback(async (val) => {
    try {
      return await ajax.post(`forms/get-all-question-types`, val);
    } catch (error) {
      return error;
    }
  });

  const getAllQuestionsOfSelectedForm = useCallback(async (val) => {
    try {
      val.department = loggedInUserData?.department?.departmentTitle;
      return await ajax.post(`forms/get-all-questions-of-selected-form`, val);
    } catch (error) {
      return error;
    }
  });

  const getQuarterlyMeetingObjectives = useCallback(async (val) => {
    try {
      const values = {
        userId: val.userId,
      };

      return await ajax.post(`forms/get-quarterly-meeting-objectives`, values);
    } catch (error) {
      return error;
    }
  });

  const getPrTargets = useCallback(async (val) => {
    try {
      const values = {
        userId: val.userId,
      };

      return await ajax.post(`forms/get-pr-targets`, values);
    } catch (error) {
      return error;
    }
  });

  const getAllQuestionsOfForm = useCallback(async (val) => {
    try {
      const values = { id: val };
      return await ajax.post(`forms/get-all-questions`, values);
    } catch (error) {
      return error;
    }
  });

  const addQuestion = useCallback(async (val) => {
    try {
      return await ajax.post(`forms/add-question`, val);
    } catch (error) {
      return error;
    }
  });
  const updateQuestion = useCallback(async (val) => {
    try {
      return await ajax.post(`forms/update-question`, val);
    } catch (error) {
      return error;
    }
  });
  const deleteQuestion = useCallback(async (val) => {
    try {
      const value = { id: val };
      await ajax.post(`forms/delete-question`, value);
    } catch (error) {
      return error;
    }
  });

  const getQuestionDetails = useCallback(async (val) => {
    try {
      const values = { id: val };
      return await ajax.post(`forms/get-question`, values);
    } catch (error) {
      return error;
    }
  });

  const getFormDetails = useCallback(async (val) => {
    try {
      const values = { id: val };
      return await ajax.post(`forms/get-form-details`, values);
    } catch (error) {
      return error;
    }
  });

  const getSections = useCallback(async (formId) => {
    try {
      const val = { formId: formId, department: loggedInUserData?.department?.departmentTitle };
      let result = await ajax.post(`forms/get-section-list`, val);
      return result;
    } catch (error) {
      return error;
    }
  });

  const sendFormToUser = useCallback(
    async (formId, users, sentBy, formName, sendForEmployee, formTrackerId, isNew) => {
      try {
        const val = {
          formId: formId,
          users: users,
          sentBy: sentBy,
          formName: formName,
          sendForEmployee: sendForEmployee,
          formTrackerId: formTrackerId,
          isNew: isNew,
        };
        let result = await ajax.post(`forms/send-form`, val);
        return result;
      } catch (error) {
        return error;
      }
    },
  );

  const sendQuarterlyObjective = useCallback(
    async (
      user,
      companyGoalsArr,
      finPrioritiesArr,
      humanCapPrioritiesArr,
      marketingPrioritiesArr,
      operationsPrioritiesArr,
    ) => {
      try {
        const val = {
          user: user,
          companyGoalsArr: companyGoalsArr,
          finPrioritiesArr: finPrioritiesArr,
          humanCapPrioritiesArr: humanCapPrioritiesArr,
          marketingPrioritiesArr: marketingPrioritiesArr,
          operationsPrioritiesArr: operationsPrioritiesArr,
        };
        let result = await ajax.post(`forms/send-quarterly-objectives`, val);
        return result;
      } catch (error) {
        return error;
      }
    },
  );

  const sendPrTargets = useCallback(async (user, prDisplayObject) => {
    try {
      const val = {
        user: user,
        prDisplayObject: prDisplayObject,
      };
      let result = await ajax.post(`forms/send-pr-targets`, val);
      return result;
    } catch (error) {
      return error;
    }
  });

  const getformEditDetail = useCallback(async (val) => {
    try {
      const values = { id: val };
      return await ajax.post(`forms/view-edit-history`, values);
    } catch (error) {
      return error;
    }
  });

  const getFormTracker = useCallback(async (val) => {
    try {
      const values = { userId: val };
      return await ajax.post(`forms/get-form-tracker`, values);
    } catch (error) {
      return error;
    }
  });

  //Tushar
  const getFormCompletedStatus = useCallback(async (val) => {
    try {
      const values = { formTrackerId: val };
      return await ajax.post(`forms/get-form-completed-status`, values);
    } catch (error) {
      return error;
    }
  });

  const getFinProgressFormTracker = useCallback(async (val) => {
    try {
      const values = { userId: val.userId, formType: val.formType };

      return await ajax.post(`forms/get-fin-progress-form-tracker`, values);
    } catch (error) {
      return error;
    }
  });

  const getFilteredAnswers = useCallback(async (val) => {
    try {
      const values = {
        userId: val.userId,
        formType: val.formType,
        startYear: val.startYear,
        endYear: val.endYear,
      };

      return await ajax.post(`forms/get-filtered-answers`, values);
    } catch (error) {
      return error;
    }
  });

  const getFinParamsUsers = useCallback(async () => {
    try {
      const values = {
        // userId: val.userId,
        // formType: val.formType,
        // startYear: val.startYear,
        // endYear: val.endYear,
      };

      return await ajax.post(`forms/get-fin-params`, values);
    } catch (error) {
      return error;
    }
  });

  const getFormYear = useCallback(async (val) => {
    try {
      const values = { userId: val.userId };
      return await ajax.post(`forms/get-form-year`, values);
    } catch (error) {
      return error;
    }
  });

  const getMyCompletedForms = useCallback(async (val) => {
    try {
      const values = { userId: val };
      return await ajax.post(`forms/get-my-completed-forms`, values);
    } catch (error) {
      return error;
    }
  });

  const getInCompletedForms = useCallback(async () => {
    try {
      //get-all-form-tracker
      const values = { sentForUser: loggedInUserData?.id };
      return await ajax.post(`forms/get-all-form-tracker`, values);
    } catch (error) {
      return error;
    }
  });

  const getCompletedForms = useCallback(async (val) => {
    try {
      return await ajax.post(`forms/get-completed-forms`, val);
    } catch (error) {
      return error;
    }
  });

  const saveForm = useCallback(async (val) => {
    try {
      let result = await ajax.post(`forms/save-form`, val);
      if (!val.autoSave || val.autoSave === undefined) navigate('/app/forms/:id');
      return result;
    } catch (error) {
      return error;
    }
  });

  const getFormResponse = useCallback(async (value) => {
    try {
      const val = { formTrackerId: value };
      let result = await ajax.post(`forms/get-form-response`, val);
      return result;
    } catch (error) {
      return error;
    }
  });

  const get360Report = useCallback(async (value, year) => {
    try {
      const val = { sentForUser: value, year: year };
      let result = await ajax.post(`forms/get-360-report`, val);
      return result;
    } catch (error) {
      return error;
    }
  });

  const getEditHistory = useCallback(async (value) => {
    try {
      const val = { formId: value };
      let result = await ajax.post(`forms/view-edit-history`, val);
      return result;
    } catch (error) {
      return error;
    }
  });

  const cancelFormRequest = useCallback(async (val) => {
    try {
      const value = { id: val };
      await ajax.post(`forms/cancel-form-request`, value);
    } catch (error) {
      return error;
    }
  });

  const approveFormRequest = useCallback(async (val) => {
    try {
      const value = { id: val };
      await ajax.post(`forms/approve-form-request`, value);
    } catch (error) {
      return error;
    }
  });

  const _360PeerReviewToEmployeePeers = useCallback(async () => {
    try {
      const val = { formName: 'formName' };
      let result = await ajax.post(`forms/send360-employe-peers`, val);
      return result;
    } catch (error) {
      return error;
    }
  });

  const quarterlyReportReminder = useCallback(async () => {
    try {
      const val = { formName: 'formName' };
      let result = await ajax.post(`forms/send-quarterly-meeting-reminder`, val);
      return result;
    } catch (error) {
      return error;
    }
  });

  const getLogiwareEmployeeList = useCallback(async () => {
    try {
      return await fetch('https://vector.logiwareinc.com/api/performance/summary/employees', {
        method: 'GET',
        mode: 'cors',
        headers: {
          'Content-Type': 'application/json',
          //Authorization: 'Bearer token',
        },
      })
        .then((response) => response.json())
        .catch((error) => console.error(error));
      // return await ajax.get(
      //   `https://vector.logiwareinc.com/api/performance/summary/employees`,
      //   val,
      // );
    } catch (error) {
      return error;
    }
  });

  const getYears = useCallback(async (val) => {
    try {
      let result = await ajax.post(`forms/get-years`, val);
      return result;
    } catch (error) {
      return error;
    }
  });

  const getLogiwareData = useCallback(async (val) => {
    try {
      let result = await ajax.post(`forms/get-logiware-data`, val);
      return result;
    } catch (error) {
      return error;
    }
  });

  const getPerformanceReview = useCallback(async (value) => {
    try {
      const val = { formId: value };
      let result = await ajax.post(`forms/get-performance-review`, val);
      return result;
    } catch (error) {
      return error;
    }
  });

  return {
    getLogiwareEmployeeList,
    getAllFormTypes,
    getFormDetails,
    getAllQuestionTypes,
    addQuestion,
    updateQuestion,
    getAllQuestionsOfSelectedForm,
    getAllQuestionsOfForm,
    deleteQuestion,
    getQuestionDetails,
    getSections,
    getformEditDetail,
    sendFormToUser,
    getFinProgressFormTracker,
    getFormTracker,
    getFormCompletedStatus,
    getInCompletedForms,
    getCompletedForms,
    getMyCompletedForms,
    saveForm,
    getFormResponse,
    get360Report,
    getEditHistory,
    getFormYear,
    cancelFormRequest,
    approveFormRequest,
    _360PeerReviewToEmployeePeers,
    getFilteredAnswers,
    getFinParamsUsers,
    getYears,
    getQuarterlyMeetingObjectives,
    sendQuarterlyObjective,
    quarterlyReportReminder,
    getLogiwareData,
    getPrTargets,
    sendPrTargets,
    getPerformanceReview,
  };
};

export default useForms;
